import { TowerAddress } from "@silo/addresses";
import { Tower, Tower__factory } from "@silo/typechain";
import { ethers } from "ethers";
import {
  ChecksumAddress,
  ProtocolInstance,
  getChecksumAddressOrThrow,
} from "@silo/types";
import { FallbackProvider } from "@ethersproject/providers";

export const fetchTowerCoordinates = async (
  provider: FallbackProvider,
  protocolInstance: ProtocolInstance,
  key: string
): Promise<ChecksumAddress> => {
  const TowerContract = <Tower>(
    new ethers.Contract(
      TowerAddress[protocolInstance],
      Tower__factory.abi,
      provider
    )
  );

  const address = await TowerContract.coordinates(key);

  return getChecksumAddressOrThrow(address);
};
